import type { PurchasePlace, PurchaseType } from "~/app/analytics/ga/recommendations/types";
import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import { getCurrentBrowserTimezone } from "~/common/utils/dateUtils";

export interface AddToQuoteApiItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;
  comment?: string;
  internalComment?: string;
  selectedDeliveryDate: string;
  primaryWarehouseCode: string;
  offerPrice?: number;
  targetPrice?: number;
  minimumSellingPrice?: number;
  recommendedSellingPrice?: number;
  priceReference?: string;
}

const apiUrl = resolveApiUrl("/quote/add/bulk");

export function sendAddToQuote(
  data: AddToQuoteApiItem | AddToQuoteApiItem[],
  _context?: { recommendationType?: PurchaseType; recommendationPlace?: PurchasePlace },
) {
  const arrayData = Array.isArray(data) ? data : [data];
  const body = {
    items: arrayData,
    userTimeZone: getCurrentBrowserTimezone(),
  };

  const packageToCartForm = JSON.stringify(body);

  return fetch(apiUrl, {
    body: packageToCartForm,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((result) => {
    window.SCHA.updateMinicart?.();
    if (!result.ok) {
      throw new Error("Failed to add items to quote");
    }
    return result;
  });
}
